import Alpine from "alpinejs";

Alpine.data("list", () => ({
    uuid: null,
    items: [],

    configuration: {},

    init(items, configuration) {
        if (configuration) this.configuration = configuration;
        if (items) this.items = items;

        window.addEventListener('message', (event) => {
            if (event.data.type === 'change-list') {
                let json = JSON.parse(event.data.data);
                this.items = json.items;
                this.configuration = json.configuration;
            }
        });
    }
}));